import { h, defineComponent } from 'vue';

/**
 * Отображение готового HTML статьи. Про редактор не знает ничего.
 *
 * Вынесен из vue-froala.js в отдельный модуль намеренно: там он лежал рядом с
 * `import FroalaEditor from 'froala-editor'`, и каждая страница статьи из-за
 * этого тянула 2,8 МБ движка, чтобы показать текст.
 */
export const FroalaView = defineComponent({
  // value — это HTML статьи (elementData.previewText/detailText, см.
  // ElementView.vue), сохранённый через сам Froala автором статьи. Это тот
  // же домен доверия, что и у контента, который редактирует Froala, — НЕ
  // произвольный пользовательский ввод. Компонент кладёт его в innerHTML
  // БЕЗ санитизации: для недоверенного HTML он не годится.
  props: ['tag', 'value'],

  watch: {
    value: function (newValue) {
      this._element.innerHTML = newValue;
    }
  },

  created: function () {
    this.currentTag = this.tag || this.currentTag;
  },

  render: function () {
    return h(
      this.currentTag,
      {
        class: 'fr-view'
      }
    )
  },

  // After first time render.
  mounted: function() {
    this._element = this.$el;

    if (this.value) {
      this._element.innerHTML = this.value
    }
  },

  data() {

    return {
      currentTag: 'div',
      _element: null,
    };
  }
})
